import React from 'react';
import { useTranslation } from 'react-i18next';
import './SettingsPages.css';
import './BillingSettings.css';

function BillingSettings() {
  const { t } = useTranslation(['profile']);

  return (
    <div className="settings-page">
      <div className="settings-page-content billing-settings">
        <p className="billing-settings-description">
          {t('profile.settings.pages.billing.description')}
        </p>
        <p className="billing-settings-lead">{t('profile.settings.pages.billing.lead')}</p>
        <ul className="billing-settings-list" aria-label={t('profile.settings.pages.billing.listAria')}>
          <li>{t('profile.settings.pages.billing.bulletPlan')}</li>
          <li>{t('profile.settings.pages.billing.bulletPayment')}</li>
          <li>{t('profile.settings.pages.billing.bulletHistory')}</li>
        </ul>
        <p className="billing-settings-note">{t('profile.settings.pages.billing.footerNote')}</p>
      </div>
    </div>
  );
}

export default BillingSettings;
